<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalGenerationSystem"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <div class="d-flex align-items-center">
            <div class="me-3">
              <img src="@/assets/images/svg-img/generation.svg" />
            </div>
            <div>
              <div class="card_title_1">GENERATION SYSTEMS</div>
              <!-- <div class="card_title_2">
                Last Updated {{ last_update_detail }}
              </div> -->
            </div>
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="gen-system">
            <div class="">
              <div style="width: 160px" class="table-responsive">
                <table
                  class="table table-light"
                  width="100%"
                  style="border-right: 2px solid white; font-size: 14px"
                >
                  <thead>
                    <tr style="width: 100px">
                      <th style="background: #dfdfdf">System</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(region, id) in data" :key="id">
                      <td
                        style="
                          color: #949494;
                          text-transform: capitalize;
                          background: #f2f2f2;
                        "
                      >
                        {{ region.system }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="gen-system-data" style="padding: 0">
              <div class="table-responsive">
                <table
                  class="table table-light"
                  style="font-size: 14px; table-layout: fixed"
                >
                  <thead>
                    <tr>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Electricity Generated (MWh)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Availability Factor IPP (%)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Equivalent Availability Factor (%)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        SOF - Scheduled Outage Factor (%)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Equivalent Force Outage Rate (%)
                      </th>
                      <!-- <th style="width: 300px">Cadangan Daya</th> -->
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Daya mampu terpasang (MW)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        BPP for Generation (IDR/kWh)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Hari Operasi HOP (days)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Net plant heat rate (Kcal/kWh)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Batubara (kg/kWh)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        BBM (liter/kWh)
                      </th>
                      <th
                        style="
                          width: 300px;
                          border-right: 2px solid white;
                          background: #dfdfdf;
                        "
                      >
                        Gas (mmbtu/kWh)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="region in data">
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{
                          formattedNumberWithDash(region.electricityGeneration)
                        }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{ formattedNumberWithDash(region.availabilityFactor) }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{
                          formattedNumberWithDash(
                            region.equivalentAvailabilityFactor
                          )
                        }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{
                          formattedNumberWithDash(region.scheduledOutageFactor)
                        }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{
                          formattedNumberWithDash(
                            region.equivalentForceOutageRate
                          )
                        }}
                      </td>
                      <!-- <td>{{ formattedNumberWithDash(region.cadanganDaya) }}</td> -->
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{ formattedNumberWithDash(region.dayaMampuTerpasang) }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{ formattedNumberWithDash(region.bppForGeneration) }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{ formattedNumberWithDash(region.hariOperasi) }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{ formattedNumberWithDash(region.netPlantHeatRate) }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{ region.batubara }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{ region.bbm }}
                      </td>
                      <td
                        style="
                          background: #f2f2f2;
                          border-right: 2px solid white;
                        "
                      >
                        {{ region.gas }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import { mapState } from "vuex";
import { formattedNumberWithDash, formattedNumberGene } from "@/utils/helper";

export default {
  props: ["showModal", "data", "last_update_detail"],
  components: {
    IconSvg,
  },

  data() {
    return {
      modal: null,
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalGenerationSystem);
  },

  methods: {
    closeModal() {
      this.$emit("closeModal", false);
    },
    formattedNumberWithDash,
    formattedNumberGene,
  },

  watch: {
    showModal() {
      if (this.showModal) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },

  computed: {
    ...mapState({
      table: (state) => state.bootsrap.table,
    }),
  },
};
</script>

<style>
.custom-modal-width {
  --bs-modal-width: 800px;
}
</style>
